/**
 * i18next Configuration
 */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'

export const SUPPORTED_LANGUAGES = {
  en: 'English',
} as const

export type SupportedLanguage = keyof typeof SUPPORTED_LANGUAGES
export const DEFAULT_LANGUAGE: SupportedLanguage = 'en'

const resources = {
  en: { translation: en },
}

const getStoredLanguage = (): SupportedLanguage => {
  const stored = localStorage.getItem('app_language')
  if (stored && stored in SUPPORTED_LANGUAGES) {
    return stored as SupportedLanguage
  }
  return DEFAULT_LANGUAGE
}

i18n.use(initReactI18next).init({
  resources,
  lng: getStoredLanguage(),
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
  defaultNS: 'translation',
  ns: ['translation'],
  debug: import.meta.env.DEV,
  react: {
    useSuspense: true,
  },
})

export default i18n
